// Enums/AxiomKeysEnum.js
export const AxiomeLogicKeysEnum = {
    EQUIVALENT_CLASS: 'http://www.w3.org/2002/07/owl#EquivalentClass',
    DISJOINT_WITH: 'http://www.w3.org/2002/07/owl#disjointWith',
    DISJOINT_UNION_OF: 'http://www.w3.org/2002/07/owl#disjointUnionOf',
    ALL_DISJOINT_CLASSES: 'http://www.w3.org/2002/07/owl#AllDisjointClasses',
    THING: 'http://www.w3.org/2002/07/owl#Thing',
    NOTHING: 'http://www.w3.org/2002/07/owl#Nothing',
    INTERSECTION_OF: 'http://www.w3.org/2002/07/owl#intersectionOf',
    UNION_OF: 'http://www.w3.org/2002/07/owl#unionOf',
    COMPLEMENT_OF: 'http://www.w3.org/2002/07/owl#complementOf',
    ONE_OF: 'http://www.w3.org/2002/07/owl#oneOf',
    SOME_VALUES_FROM: 'http://www.w3.org/2002/07/owl#someValuesFrom',
    HAS_VALUE: 'http://www.w3.org/2002/07/owl#hasValue',
    HAS_SELF: 'http://www.w3.org/2002/07/owl#hasSelf',
    CARDINALITY: 'http://www.w3.org/2002/07/owl#cardinality',
    QUALIFIED_CARDINALITY: 'http://www.w3.org/2002/07/owl#qualifiedCardinality',
    ON_CLASS: 'http://www.w3.org/2002/07/owl#onClass',
    ON_PROPERTY: 'http://www.w3.org/2002/07/owl#onProperty',
    MAX_CARDIALITY: 'http://www.w3.org/2002/07/owl#maxCardinality',
    MIN_QUALIFIED_CARDINALITY: 'http://www.w3.org/2002/07/owl#minQualifiedCardinality',
    MAX_QUALIFIED_CARDINALITY: 'http://www.w3.org/2002/07/owl#maxQualifiedCardinality',
    ALL_VALUES_FROM: 'http://www.w3.org/2002/07/owl#allValuesFrom',
    ON_DATA_RANGE: 'http://www.w3.org/2002/07/owl#onDataRange',
    MIN_CARDINALITY: 'http://www.w3.org/2002/07/owl#minCardinality',
    TYPE: 'http://www.w3.org/2000/01/rdf-schema#type',
    SUBCLASS_OF: 'http://www.w3.org/2000/01/rdf-schema#subClassOf',
};
export default AxiomeLogicKeysEnum;